import axios from 'axios';
import authHeader from './auth-header';

// const API_URL = 'http://localhost:8080/api/test/';
const API_URL = 'https://hablarjuntos.com:5088/users/';

class UserService {
  getPublicContent() {
    return axios.post(API_URL + 'public');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.post(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.post(API_URL + 'admin', { headers: authHeader() });
  }
}

export default new UserService();